import { ColumnMapDefinition } from 'src/app/domainObjects/columnMapDefinition';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataDictionaryType } from 'src/app/domainObjects/dataDictionaryType';
import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { OptionItem, OptionItemDataType } from 'src/app/model/optionItem';
import { DataDictionaryItem, DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { TransformerViewModel } from 'src/app/views/transformer-list/transformer-list.component';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { DataTransform } from '../../../../../domainObjects/dataTransform';
import { PreviewDataImportResponse } from '../../../../../messaging/previewDataResponse';
import { ColumnDefinition } from '../../../../../domainObjects/columnDefinition';
import { TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { ValidationInfo } from 'src/app/objectModel/validationInfo';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { TransformerParametersViewModel } from 'src/app/views/transform/transformerDetail/transformer-parameters/transformerParametersViewModel';

export class FilterSet {
  previewInputFilters?: ColumnFilter[];
  previewOutputFilters?: ColumnFilter[];
  transformFilters?: ColumnFilter[];
}

export abstract class TransformDetailViewModelBase<TTransform extends DataTransform<any>> {
  transformConfigId?: number;
  transform: TTransform;
  isTransformRunning = false;
  dataFarms: Array<DataFarmViewModel>;
  sourceColumns: OptionItem[];
  sourceColumnsDT: OptionItemDataType[];
  /** Farm-native (index) column order — sourceColumns/sourceColumnsDT are
   * alphabetically re-sorted below, so this is the only place natural order
   * survives. Needed by anything that means "the Nth column of the farm",
   * e.g. Column Cleaner's Smart Sample fallback (first field after "row"). */
  sourceColumnsNaturalOrder: string[] = [];
  OptionsourceColumns: string[] =[];
  OptionsourceColumnsString: string[] =[];
  targetColumns: Array<string>;
  dataFarm: DataFarmViewModel;
  subTitle: string;
  sortInputFarm = true;
  sortInfo?: SortInfo[];
  lastSortInfoJson?: string;
  includeInResults?: IncludeInfo[];
  parameters?: TransformerParametersViewModel;
  targetColumn?: string;
  validationInfo?: ValidationInfo[];
  sampleStart?: number;
  sampleEnd?: number;

  constructor(
    private dataDictService: DataDictionaryService,
    protected configViewModel: DataTransformConfigViewModel,
    public transformViewModel: TransformerViewModel) {

    this.transform = transformViewModel.transform as TTransform;
    this.subTitle = `${this.configViewModel.name} Sequence ${this.transform.index}: ${TransformTypeUtil.toString(this.transform.transformType)}`;

    // TODO: Verify how / what DataFarms we are using to select from
    const farms = this.configViewModel.ingestConfigs.map(item => {
      return new DataFarmViewModel(
        item.id,
        item.name,
        item.columnMap,
        item.columns,
        item.dataConnector,
        item.targetDataFarm,
        item.guid);
    });

    this.dataFarms = farms;

    // Default data farm
    const selectedDataFarm = this.dataFarms
      .find(f => f.guid === this.configViewModel.selectedIngestFarmGuid);

    this.onDataFarmSelected(selectedDataFarm ?? this.dataFarms[0]);
    //this.configureTargetColumns();

    this.validationInfo = this.configureValidationInfo();
  }

  getValidationInfo(name: string): ValidationInfo {
    return this.validationInfo.find(f => f.fieldName === name);
  }

  configureValidationInfo(): ValidationInfo[] {
    return [];
  }

  onDataFarmSelected(dataFarm: DataFarmViewModel): void {
    //console.log(`selected farm: ${dataFarm.name}`);

    this.dataFarm = dataFarm;
    this.configViewModel.selectedIngestFarmGuid = this.dataFarm.guid;
  }

  async refreshDataTransformConfigViewModelAsync(viewModel: DataTransformConfigViewModel): Promise<void> {
    this.configViewModel = viewModel;
  }

  updateInputFarmColumns(columns: ColumnDefinition[]): void {
    // Captured before the alphabetical .sort() below mutates `columns` in place.
    this.sourceColumnsNaturalOrder = columns.map(c => c.columnName);

    this.sourceColumns = columns
      .sort((a, b) => a.columnName < b.columnName ? -1 : 0)
      .map(c => new OptionItem(c.columnName, c.columnName));

    this.sourceColumnsDT = columns
      .sort((a, b) => a.columnName < b.columnName ? -1 : 0)
      .map(c => new OptionItemDataType(c.columnName, c.columnName,c.pyDataType));

     this.OptionsourceColumns = this.sourceColumns.map(item => item.text);
     this.OptionsourceColumnsString = columns.filter(col=>col.pyDataType=="object" || col.pyDataType=="string").map(item => item.columnName);
      //console.log("this.sourceColumns===",this.sourceColumns);
  }

  private configureTargetColumns(): void {
    let dataDictionaryItems: DataDictionaryItem[];

    switch (this.dataFarm.dataFarmType) {
      case DataFarmType.activity:
        dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.activity);
        this.targetColumns = dataDictionaryItems.map(i => i.Field);
        break;
      case DataFarmType.subTask:
        dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.subTask);
        this.targetColumns = dataDictionaryItems.map(i => i.Field);
        break;
      case DataFarmType.task:
        dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.task);
        this.targetColumns = dataDictionaryItems.map(i => i.Field);
        break;
      case DataFarmType.cases:
        dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.case);
        this.targetColumns = dataDictionaryItems.map(i => i.Field);
        break;
      case DataFarmType.users:
        dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.user);
        this.targetColumns = dataDictionaryItems.map(i => i.Field);
        break;
      case DataFarmType.behaviors:
        dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.behavior);
        this.targetColumns = dataDictionaryItems.map(i => i.Field);
        break;
         case DataFarmType.master:
        dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.master);
        this.targetColumns = dataDictionaryItems.map(i => i.Field);
        break;
    }

    this.targetColumns.sort((a, b) => a < b ? -1 : 0);
  }

  public buildDataConnectorMappings(): DataConnectorMapping[] {
    return this.dataFarms.map(df => {
      const colMap = df.columnMappings.map(c => {
        return new ColumnMapDefinition(c.id, c.columnName, c.targetColumnName, c.dataType, c.pyDataType);
      });

      return new DataConnectorMapping(
        df.id,
        df.name,
        df.dataFarmType,
        df.dataConnector.toDataConnector(),
        colMap,
        df.guid
      );
    });
  }

  getDefaultTimestampColumn(): string {

    return this.dataFarm.columnMappings
      .filter(t => t.targetColumnName !== null && t.targetColumnName?.length > 0)
      .find(t => t.dataType === 'Timestamp')
      ?.targetColumnName;
  }

  public abstract onTransformRunCompleted<T extends PreviewDataImportResponse>(response: T): void;
  public abstract toTransformConfig(): any;
}
